// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1ACND","selected":"Chip_selected__2ayWw"};